import combineActionHandlers from "@web-monorepo/infra/combineActionHandlers";
import { PodInstallFunction } from "@web-monorepo/shared/podInfra";
import { autoTranslate } from "@web-monorepo/vite-auto-translate-plugin/runtime";
import createKeyducer from "src/infra/createKeducer";
import { AppMetadata } from "src/pods/toolkitData/components/EditableSetup";
import icon from "./assets/logo.svg";

export const appMetadataTimer = (): AppMetadata => ({
  href: "timer",
  title: autoTranslate("Timer"),
  backgroundColor: "dt_content_accent",
  icon,
  textColor: "#000000",
  // titleColor: "dt_content_light",
});

export type Timer = {
  seconds?: number;
  startTime?: number | null;
  endTime?: number | null;
  remainingTime?: number | null;
  increment?: number | null;
  reset?: boolean;
};

const {
  reducerHandler,
  actionCreator: sendTime,
  action: RECEIVE_TIME,
} = createKeyducer<Timer>("RECEIVE_TIME", (time) => ({
  seconds: time.seconds,
  startTime:
    time.startTime && time.seconds
      ? Date.now() - (time.seconds * 1000 - (time.remainingTime || time?.seconds * 1000))
      : null,
  endTime: time.endTime ? Date.now() : null,
}));

export { RECEIVE_TIME, sendTime };

const STATE_KEY = "timer";

export type TimerSlice = {
  [STATE_KEY]: Timer;
};

const install: PodInstallFunction = (installReducer) => {
  const reducer = combineActionHandlers({}, [reducerHandler]);
  installReducer(STATE_KEY, reducer);
};

export default install;

export const selectTime = (state: TimerSlice) => state?.[STATE_KEY];
